import Icon from "@ant-design/icons";

const SendIconSVG = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.50837 18.125C3.57504 18.125 2.98337 17.8083 2.60837 17.4333C1.87504 16.7 1.35837 15.1416 3.00837 11.8333L3.73337 10.3916C3.82504 10.2 3.82504 9.79996 3.73337 9.60829L3.00837 8.16663C1.35004 4.85829 1.87504 3.29162 2.60837 2.56662C3.33337 1.83329 4.90004 1.30829 8.20004 2.96662L15.3334 6.53329C17.1084 7.41662 18.0834 8.64996 18.0834 9.99996C18.0834 11.35 17.1084 12.5833 15.3417 13.4666L8.20837 17.0333C6.59171 17.8416 5.3917 18.125 4.50837 18.125ZM4.50837 3.12496C4.05837 3.12496 3.70837 3.23329 3.49171 3.44996C2.88337 4.04996 3.12504 5.60829 4.12504 7.59996L4.85004 9.04996C5.11671 9.59162 5.11671 10.4083 4.85004 10.95L4.12504 12.3916C3.12504 14.3916 2.88337 15.9416 3.49171 16.5416C4.09171 17.15 5.65004 16.9083 7.65004 15.9083L14.7834 12.3416C16.0917 11.6916 16.8334 10.8333 16.8334 9.99162C16.8334 9.14996 16.0834 8.29162 14.775 7.64162L7.64171 4.08329C6.37504 3.44996 5.28337 3.12496 4.50837 3.12496Z"
      fill="currentColor"
    />
    <path
      d="M9.03345 10.625H4.53345C4.19178 10.625 3.90845 10.3417 3.90845 10C3.90845 9.65833 4.19178 9.375 4.53345 9.375H9.03345C9.37511 9.375 9.65845 9.65833 9.65845 10C9.65845 10.3417 9.37511 10.625 9.03345 10.625Z"
      fill="currentColor"
    />
  </svg>
);
const SendIcon = (props) => <Icon component={SendIconSVG} {...props} />;

export default SendIcon;
